import React, { useEffect, useState } from 'react';
import { Modal, Form, Select, message } from 'antd';
import { assignWorkOrder, getProviderUsers, WorkOrderQueryResponse } from '@/api/workorder';

interface AssignModalProps {
  open: boolean;
  record: WorkOrderQueryResponse;
  onClose: () => void;
  onSuccess: () => void;
}

const AssignModal: React.FC<AssignModalProps> = ({ open, record, onClose, onSuccess }) => {
  const [form] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage();
  const [providerList, setProviderList] = useState<any[]>([]);

  useEffect(() => {
    if (open) {
      form.resetFields();
      getProviderUsers().then((resp: any) => {
        if (resp.success && resp.result) {
          setProviderList(resp.result);
        }
      });
    }
  }, [open, form]);

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      const resp = await assignWorkOrder({
        id: record.id,
        providerId: values.providerId,
      });
      if (resp.success) {
        messageApi.success('分配成功');
        onSuccess();
      } else {
        messageApi.error(resp.errorMsg || '分配失败');
      }
    } catch {}
  };

  return (
    <>
      {contextHolder}
      <Modal
        title={`分配服务商 - ${record.orderNo || ''}`}
        open={open}
        onOk={handleOk}
        onCancel={onClose}
        okText="确定"
        cancelText="取消"
        maskClosable={false}
        destroyOnHidden
      >
        <Form form={form} layout="vertical" style={{ marginTop: 16 }}>
          <Form.Item label="服务商" name="providerId" rules={[{ required: true, message: '请选择服务商' }]}>
            <Select
              placeholder="请选择服务商"
              showSearch
              optionFilterProp="label"
              options={providerList.map((u: any) => ({
                label: u.nickName || u.username,
                value: u.id,
              }))}
            />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default AssignModal;
